import { gtag } from './gtag'
import { meta } from './meta'
import { northbeam } from './northbeam'
import { trackEvent } from './track_event'
import { Flow, SignupData, SignupResponseSuccess } from '../types'

export async function trackStepStarted(
  flow: Flow,
  step: number,
  data: Record<string, unknown>,
) {
  const censoredData = getCensoredSignupData(data)
  const eventID = createUniqueID()

  meta.trackStep(flow, step, censoredData, eventID)
  await trackEvent.trackStep(flow, step, censoredData, eventID)
  gtag.trackStep(flow, step, censoredData)
  northbeam.trackStep(flow, step, censoredData)
}

export async function trackSignupCompleted(
  flow: Flow,
  data: Record<string, unknown>,
  response: SignupResponseSuccess,
) {
  const censoredData = getCensoredSignupData(data)
  const eventID = createUniqueID()

  meta.trackSuccess(flow, censoredData, response, eventID)
  await trackEvent.trackSuccess(flow, censoredData, response, eventID)
  await gtag.trackSuccess(flow)
  northbeam.trackSuccess(flow, response)
}

/**
 * Returns a copy of the signup data with censored data removed.
 */
export function getCensoredSignupData(data: SignupData): SignupData {
  const censoredData = structuredClone(data)

  if (censoredData.account) {
    censoredData.account.password = 'REDACTED'
  }

  if (censoredData.address) {
    censoredData.address.address1 = 'REDACTED'
  }

  return censoredData
}

/**
 * Create a unique ID that can be used for deduping.
 */
export function createUniqueID() {
  // Use current date and time as a base to ensure uniqueness over time
  const timestamp = new Date().getTime()

  // Generate a random sequence for additional randomness
  const randomSequence =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)

  // Combine the timestamp and the random sequence into a single identifier
  return `evt-${timestamp}-${randomSequence}`
}
